<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center no-padding-bottom">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <br><br><br>
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">

                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase" v-html="title"></h3>
                                    <br>
                                    <span class="text-danger" v-html="description"></span>
                                </div>
                                <div class="col-4 text-right">
                                    <router-link
                                        to="/"
                                        class="btn btn-danger"
                                    >
                                        <i class="fa fa-reply"></i>
                                        Back
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div v-if="! submitted || editApplication">
                            <!-- this is hospital's profile template -->
                            <ProfileData
                                :id="application.id"
                                :data="application"
                                :transaction="application.transaction"
                                :loadCpdInfo="loadCpdInfo"
                                :displayPhoto="displayPhoto"
                                v-if="showProfileData && application && application.cpd && ! isLoadingBlade"
                            />

                            <!-- Import Profile Photo template here -->
                            <MDPhoto
                                :id="application.cpd.id"
                                :application="application"
                                :loadCpdInfo="loadCpdInfo"
                                :displayProfileData="displayProfileData"
                                :displayDirectorData="displayDirectorData"
                                v-if="showPhoto && application && application.cpd
                                        && application.cpd.staff && ! isLoadingBlade"
                            />

                            <!-- this is cpd's directors template -->
                            <DirectorData
                                :id="application.id"
                                :application="application"
                                :loadCpdInfo="loadCpdInfo"
                                :displayPhoto="displayPhoto"
                                :displayStaffData="displayStaffData"
                                v-if="showDirectorData && application && application.cpd
                                        && application.cpd.directors && ! isLoadingBlade"
                            />

                            <!-- this is hospital's Staff template -->
                            <StaffData
                                :id="application.id"
                                :application="application"
                                :loadCpdInfo="loadCpdInfo"
                                :displayDirectorData="displayDirectorData"
                                :displayConsultantData="displayConsultantData"
                                v-if="showStaffData && application && application.cpd
                                        && application.cpd.staff && ! isLoadingBlade"
                            />

                            <!-- this is hospital's facility template -->
                            <ConsultantData
                                :id="application.id"
                                :application="application"
                                :loadCpdInfo="loadCpdInfo"
                                :displayStaffData="displayStaffData"
                                :displayDocuments="displayDocuments"
                                v-if="showConsultantData && application && application.cpd
                                        && application.cpd.consultants && ! isLoadingBlade"
                            />

                            <!-- this is cpd's documents -->
                            <Documents
                                :application="application"
                                :documents="application.documents"
                                :loadCpdInfo="loadCpdInfo"
                                :displayConsultantData="displayConsultantData"
                                :displaySummary="displaySummary"
                                v-if="showDocuments && application && application.documents && ! isLoadingBlade"
                            />

                            <!-- this is application summary template -->
                            <VerificationSummary
                                :application="application"
                                :displayDocuments="displayDocuments"
                                :resubmit="false"
                                v-if="showSummary && application && ! isLoadingBlade"
                            />

                            <div class="col-lg-12" v-if="isLoadingBlade">
                                <div class="d-flex justify-content-center">
                                    <img :src="loadingBladeUrl" />
                                </div>
                            </div>

                            <div class="col-lg-12 text-center" v-if='showErrorStatus && ! isLoadingBlade'>
                                <base-alert :type="errorType">
                                    <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> -->
                                    <span class="alert-inner--text">
                                        <h2 class="text-white">{{errorMsg}}</h2>
                                    </span>
                                </base-alert>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import ProfileData from './ProfileData';
    import MDPhoto from './MDPhoto.vue';
    import DirectorData from './DirectorData';
    import StaffData from './StaffData';
    import ConsultantData from './ConsultantData';
    import Documents from './Documents.vue';
    import VerificationSummary from './VerificationSummary/VerificationSummary';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'ApplicationForm',
        components: {
            ProfileData,
            MDPhoto,
            DirectorData,
            StaffData,
            ConsultantData,
            Documents,
            VerificationSummary
        },
        data() {
            return {
                application: null,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isLoadingBlade: true,
                showProfileData: true,
                showDirectorData: false,
                showConsultantData: false,
                showStaffData: false,
                showSummary: false,
                showPhoto: false,
                showDocuments: false,
                code: this.$route.name,
                title: null,
                description: null,
                editApplication: false
            }
        },
        computed: {
            ...mapGetters(['websiteUrl', 'loadingBladeUrl']),
            submitted() {
                return this.hospital && (this.hospital.status == 'submitted' || this.hospital.status == 'approved'
                    || this.hospital.status == 'rejected');
            }
        },
        methods: {
            ...mapActions(['getPendingApplication', 'getLocations']),
            editAssessmentApp() {
                return this.editApplication = true;
            },
            loadTitle() {// load title
                return this.title = this.replaceString(this.code);
            },
            replaceString(value) {
                return value ? value.replace('-', ' ') : 'Application Form';
            },
            changeTitle(value, des, status) {// change title
                let description = des ? des : 'Kindly fill the form below with correct information...';
                if(status) {
                    this.title = value;
                    this.description = description;
                } else {
                    this.loadTitle();
                }
            },
            loadCpdInfo() {
                this.isLoadingBlade = true;
                this.application = null;
                this.getPendingApplication('application').then((res) => {
                    this.isLoadingBlade = false;
                    if(res.status) {
                        this.loadTitle();
                        this.application = res.application;
                        if(! res.application) {
                            return window.location.href = '/';
                        }
                    } else {
                        let msg = 'Payment has not been made, proceed to make payment'
                        swal.fire("Payment Failed!", msg, "warning");
                        setTimeout(function() { window.location.href = '/application-generate'; }, 3000);
                    }
                }).
                catch(() => {
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Network Failure!, kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            displayProfileData(value) {
                this.showProfileData = value;
                this.showDirectorData = ! value;
                this.showStaffData = ! value;
                this.showSummary = ! value;
                this.showPhoto = ! value;
                this.showConsultantData = ! value;
                this.showDocuments = ! value;
            },
            displayPhoto(value) {
                this.showProfileData = ! value;
                this.showDirectorData = ! value;
                this.showStaffData = ! value;
                this.showSummary = ! value;
                this.showPhoto = value;
                this.showConsultantData = ! value;
                this.showDocuments = ! value;
            },
            displayDirectorData(value) {
                this.showProfileData = ! value;
                this.showStaffData = ! value;
                this.showSummary = ! value;
                this.showDirectorData = value;
                this.showConsultantData = ! value;
                this.showPhoto = ! value;
                this.showDocuments = ! value;
            },
            displayStaffData(value) {
                this.showProfileData = ! value;
                this.showDirectorData = ! value;
                this.showSummary = ! value;
                this.showStaffData = value;
                this.showConsultantData = ! value;
                this.showPhoto = ! value;
                this.showDocuments = ! value;
            },
            displayConsultantData(value) {
                this.showProfileData = ! value;
                this.showDirectorData = ! value;
                this.showStaffData = ! value;
                this.showSummary = ! value;
                this.showConsultantData = value;
                this.showPhoto = ! value;
                this.showDocuments = ! value;
            },
            displayDocuments(value) {
                this.showProfileData = ! value;
                this.showDirectorData = ! value;
                this.showStaffData = ! value;
                this.showSummary = ! value;
                this.showConsultantData = ! value;
                this.showPhoto = ! value;
                this.showDocuments = value;
            },
            displaySummary(value) {
                this.showProfileData = ! value;
                this.showDirectorData = ! value;
                this.showStaffData = ! value;
                this.showConsultantData = ! value;
                this.showSummary = value;
                this.showPhoto = ! value;
                this.showDocuments = ! value;
            }
        },
        created() {
            this.loadCpdInfo();
            this.getLocations();
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>